export const VALIDATE_PHONE_NUMBER_ERROR = 'Validate/format Phone Number error'
